import {v4 as uuidv4} from 'uuid'

function hashString(str: string, characters: number) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0; // Convert to 32-bit integer
    }
    return Math.abs(hash).toString(16).padStart(8, '0').slice(0, characters); // Ensure 8 characters
}

export const generateDeviceUUID = (): string | Promise<string> => {
    const DEVICE_UUID_KEY = '___DEVICE_UUID___'
    let _deviceUuid = localStorage.getItem(DEVICE_UUID_KEY)
    let tizenDUID = localStorage.getItem('TIZEN_DUID')
    let deviceModel = localStorage.getItem('deviceModel')

    if(_deviceUuid) {
        return _deviceUuid
    }
    
    const tizen = window?.tizen
    const webOS = window?.webOS ?? window?.webos

    if ((typeof tizen !== 'undefined' && tizen.systeminfo) || (tizenDUID && tizenDUID.length > 0)) {
            let duid
            let device_model
            if(tizenDUID) {
                duid = tizenDUID
            } else if (typeof tizen !== 'undefined') {
                duid = tizen.systeminfo.getCapability("http://tizen.org/system/tizenid");
            }

            if(deviceModel) {
                device_model = deviceModel
            } else if(typeof tizen !== 'undefined') {
                device_model = tizen.systeminfo.getCapability("http://tizen.org/system/model_name")
            }
            localStorage.setItem('deviceModel', device_model)

            const uuid = [
                hashString(navigator.userAgent, 8),
                hashString(navigator.platform, 4),
                hashString(navigator.language || 'en-US', 4),
                hashString(new Date().getTimezoneOffset().toString(), 4),
                hashString(duid, 12),
            ].join("-");

            return uuid;
    } 
    else if (typeof webOS !== 'undefined' && !!(window as any)?.['PalmSystem']) {
        return new Promise((resolve) => {
            webOS.service.request('luna://com.webos.service.sm', {
                method: 'deviceid/getIDs',
                parameters: {
                    idType: ['LGUDID'],
                },
                onSuccess: function (inResponse: any) {
                    const uuid = inResponse.idList[0]?.idValue;

                    if (uuid) {
                        localStorage.setItem(DEVICE_UUID_KEY, uuid); // Store the generated UUID
                        resolve(uuid); // Resolve with UUID
                    } else {
                        resolve(uuidv4()); // Fallback if UUID not found
                    }
                },
                onFailure: function (inError: any) {
                    console.log('DebugTV uuidv4 fallback due to error', inError);
                    resolve(uuidv4()); // Fallback on failure
                },
            });
        }); 
    }
    
    // If neither Tizen nor WebOS is detected, return null
    return uuidv4();
}
